import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Check, CreditCard, Rocket } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function TrialOnboarding() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <Card className="w-full max-w-lg">
        <CardHeader className="text-center">
          <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
            <Check className="w-8 h-8 text-green-600" />
          </div>
          <CardTitle className="text-2xl font-bold text-ingesta-blue-600">
            Account Created!
          </CardTitle>
          <CardDescription className="text-base">
            Welcome to Ingesta. Let's get you set up with your 7-day free trial.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <CreditCard className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-medium text-blue-900">No credit card required</p>
                <p className="text-sm text-blue-800 mt-1">
                  Enjoy full access for 7 days. We'll remind you before your trial ends.
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <h3 className="font-medium text-gray-900">What's included in your trial:</h3>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-gray-600">
                <Check className="w-4 h-4 text-green-600" />
                Unlimited document uploads
              </li>
              <li className="flex items-center gap-2 text-sm text-gray-600">
                <Check className="w-4 h-4 text-green-600" />
                AI-powered dashboard generation
              </li>
              <li className="flex items-center gap-2 text-sm text-gray-600">
                <Check className="w-4 h-4 text-green-600" />
                Export to PDF & PowerPoint
              </li>
              <li className="flex items-center gap-2 text-sm text-gray-600">
                <Check className="w-4 h-4 text-green-600" />
                Share with unlimited stakeholders
              </li>
            </ul>
          </div>

          <div className="pt-4 border-t">
            <Button
              className="w-full"
              size="lg"
              onClick={() => navigate('/onboarding')}
            >
              <Rocket className="w-4 h-4 mr-2" />
              Continue Setup
            </Button>
            <p className="text-xs text-center text-gray-500 mt-3">
              Next: Set up your profile and workspace
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
